//Returns "None" if value is 0
//Example: "$0.00" returns "None"
export default function noneIfZero(value) {
	return value && Number(value.replace(/[^0-9.-]+/g, "")) !== 0
		? value
		: "None";
}
